import React, { useState } from "react"
import PropTypes from "prop-types"
import { Checkbox, Table } from "@bitcine/cs-theme"

const AddExistingUsers = ({ attachedUserIDs, allUsers, parentUsers, roleUsers, onBack, updateUsersAccess }) => {
  const [selectedUserIDs, setSelectedUserIDs] = useState([])
  const addUsers = () => {
    updateUsersAccess([...attachedUserIDs, ...selectedUserIDs], () => onBack())
  }
  const unattachedUsers = allUsers.filter(user => {
    return !attachedUserIDs?.find(id => id === user._id)
      && !roleUsers.find(roleUser => roleUser._id === user._id)
      && !parentUsers.find(parentUser => parentUser._id === user._id)
  })
  const allMembersWithoutAccess = unattachedUsers.map(user => {
    return { ...user, role_name: allUsers.find(opt => opt._id === user._id)?.role_name || "No Role" }
  })
  return (
    <div>
      <Table
        className='my3'
        widths={[55, "auto", 300, 200]}
        header={{
          columns: [{ text: "" }, { text: "Name" }, { text: "Email" }, { text: "Role" }]
        }}
        body={{
          data: allMembersWithoutAccess,
          row: {
            onClick: (e, data) => {
              if (selectedUserIDs.includes(data._id)) {
                setSelectedUserIDs(selectedUserIDs.filter(id => id !== data._id))
              } else {
                setSelectedUserIDs([...selectedUserIDs, data._id])
              }
            },
            compact: true,
            render: [
              data => <Checkbox
                checked={selectedUserIDs.includes(data._id)}
                onChange={e => {
                  if (e.target.checked) {
                    setSelectedUserIDs([...selectedUserIDs, data._id])
                  } else {
                    setSelectedUserIDs(selectedUserIDs.filter(id => id !== data._id))
                  }
                }} />,
              data => data.full_name,
              data => data.email,
              data => data.role_name || "No Role",
            ]
          },
          empty: {
            title: "All team members have access",
            text: "Everyone on your team can access this.",
            icon: "check_circle"
          }
        }} />
      <div className='flex justify-end'>
        <button className='cs-button white' onClick={onBack}>Back</button>
        <button
          disabled={selectedUserIDs.length === 0}
          className='cs-button ml1'
          onClick={addUsers}>Add Selected User{selectedUserIDs.length === 1 ? '' : 's'}</button>
      </div>
    </div>
  )
}

AddExistingUsers.propTypes = {
  allUsers: PropTypes.array,
  attachedUsers: PropTypes.array,
  roleUsers: PropTypes.array,
  parentUsers: PropTypes.array
}

export default AddExistingUsers